import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICreditNote, ICreditNoteDetail } from "src/models/Accounting/CreditNotes.models";

interface CreditNoteState {
    creditNotes: ICreditNote[];
    creditNoteToEdit: ICreditNote | null;
    creditNoteDetailsToEdit: ICreditNoteDetail[] | [];
}

const initialState: CreditNoteState = {
    creditNotes: [],
    creditNoteToEdit: null,
    creditNoteDetailsToEdit: [],
};

const CreditNoteSlice = createSlice({
    name: "CreditNote",
    initialState,
    reducers: {
        setCreditNoteList: (state, action: PayloadAction<ICreditNote[]>) => {
            state.creditNotes = action.payload;
        },
        setURLToACreditNoteToEdit: (
            state,
            action: PayloadAction<string | null>
        ) => {
            if (state.creditNoteToEdit)
            state.creditNoteToEdit.url = action.payload;
        },
        concatListCreditNote: (
            state: CreditNoteState,
            action: PayloadAction<ICreditNote[]>
        ) => {
            state.creditNotes = [...state.creditNotes.concat(action.payload)];
        },
        setCreditNoteToEdit: (state, action: PayloadAction<ICreditNote | null>) => {
            state.creditNoteToEdit = action.payload;
        },
        setCreditNoteDetailsToEdit: (state, action: PayloadAction<ICreditNoteDetail[]>) => {
            state.creditNoteDetailsToEdit = action.payload;
        },
        addCreditNote: (state, action: PayloadAction<ICreditNote>) => {
            state.creditNotes.push(action.payload);
        },
        addCreditNotes: (state, action: PayloadAction<ICreditNote[]>) => {
            state.creditNotes.push(...action.payload);
        },
        updateCreditNote: (state, action: PayloadAction<ICreditNote>) => {
            let itemIndex = state.creditNotes.findIndex(
                item => item.creditNoteId === action.payload.creditNoteId
            );
            if (itemIndex !== -1) state.creditNotes[itemIndex] = action.payload;
        },
        updateCustomerFieldsInCreditNote: (state, action: PayloadAction<ICreditNote>) => {
            if (state.creditNoteToEdit) {
                state.creditNoteToEdit.customerName = action.payload.customerName;
                state.creditNoteToEdit.customerId = action.payload.customerId;
                state.creditNoteToEdit.customerCode = action.payload.customerCode;
            }
        },
        deleteCreditNote: (state, action: PayloadAction<number>) => {
            const newArray = state.creditNotes.filter(
                item => item.creditNoteId !== action.payload
            );
            state.creditNotes = newArray;
        },
    },
});

export const {
    setCreditNoteList,
    concatListCreditNote,
    setCreditNoteDetailsToEdit,
    setCreditNoteToEdit,
    addCreditNote,
    addCreditNotes,
    updateCreditNote,
    updateCustomerFieldsInCreditNote,
    deleteCreditNote,
    setURLToACreditNoteToEdit,
} = CreditNoteSlice.actions;

export default CreditNoteSlice.reducer;